var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey--text text--darken-4 grey lighten-3 rounded-xl px-4 pt-2 bubble-size ml-3",attrs:{"id":"wave"}},[_c('span',{staticClass:"dot one",style:(`background-color: #212121`)}),_c('span',{staticClass:"dot two",style:(`background-color: #212121`)}),_c('span',{staticClass:"dot three",style:(`background-color: #212121`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }